import { Pipe, PipeTransform } from '@angular/core';

import { Defaults } from 'src/app/config/defaults';

import isIsoDate from 'is-iso-date';
import lodash from 'lodash';
import { DateTime } from 'luxon';
import { titleCase } from 'title-case';

export const strongTitleCase = (text: string) => {
  if (!text) {
    return text;
  }

  const partials = text.split('_')
    .filter((element) => !!element);

  return partials.map(titleCase).join(' ');
};

@Pipe({
  name: 'humanize',
})
export class HumanizePipe implements PipeTransform {
  transform(value: any, type = 'string', emptyValue = Defaults.EmptyValue): any {
    // In case the value is empty or not available.
    if (lodash.isNil(value)) {
      return emptyValue;
    }

    switch (type) {
      case 'number': {
        const floatValue = Number(value || 0);

        if (lodash.isInteger(floatValue)) {
          return lodash.toInteger(floatValue);
        }

        return floatValue.toFixed(2);
      }

      case 'date': {
        if (!isIsoDate(value)) {
          return value;
        }

        return DateTime
          .fromFormat(value, 'yyyy-MM-dd')
          .toFormat('DD');
      }

      case 'time': {
        if (!isIsoDate(value)) {
          return value;
        }

        return DateTime
          .fromISO(value)
          .toFormat('ff');
      }

      case 'title': {
        if (!value) {
          return null;
        }

        return strongTitleCase(value);
      }

      default: {
        return value;
      }
    }
  }
}
